<template>
  <el-dialog
    title="SEM数据编辑窗口"
    :visible.sync="visible"
    @close="close">

    <el-form :inline="true" :model="SemEditForm" label-position="right">
      <el-form-item label="SEM_ID">
        <el-input v-model="SemEditForm.sem_id" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item label="数据开始时间UTC">
        <el-date-picker v-model="SemEditForm.date_utc" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" style="width:260px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="观测天次">
        <el-input v-model="SemEditForm.hxmt_day" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item label="数据开始时间mjd">
        <el-input v-model="SemEditForm.date_mjd" autocomplete="off" style="width:220px;"></el-input>
      </el-form-item>
      <el-form-item label="观测时长">
        <el-input v-model="SemEditForm.duration" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item label="数据开始时间(TT)">
        <el-input v-model="SemEditForm.start_tt" autocomplete="off" ></el-input>
      </el-form-item>
      <el-form-item label="数据状态">
        <el-select style="width:260px;" v-model="SemEditForm.status"  filterable placeholder="数据状态">
              <el-option
                  v-for="item in status_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据结束时间tt">
        <el-input v-model="SemEditForm.stop_tt" autocomplete="off" ></el-input>
      </el-form-item>        
      <el-form-item label="文件__ID">
        <el-input v-model="SemEditForm.file_id" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item label="数据发布时间">
        <el-date-picker v-model="SemEditForm.release_date" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
      </el-form-item>      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {datastatus_IE} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      SemEditForm:{
        sem_id:'',
        date_utc:'',
        date_mjd:'',
        hxmt_day:'',
        start_tt:'',
        stop_tt:'',
        duration:'',
        status:'',
        file_id:'',
        release_date:'',  
        ind:'',   
      },
      status_list:datastatus_IE,
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.SemEditForm.sem_id = data.sem_id;
      this.SemEditForm.date_utc = data.date_utc;
      this.SemEditForm.date_mjd = data.date_mjd;
      this.SemEditForm.hxmt_day = data.hxmt_day;
      this.SemEditForm.start_tt = data.start_tt;
      this.SemEditForm.stop_tt = data.stop_tt;
      this.SemEditForm.duration = data.duration;
      this.SemEditForm.status = data.status;
      this.SemEditForm.file_id = data.file_id;
      this.SemEditForm.release_date = data.release_date;
      this.SemEditForm.ind = data.ind;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      
      this.$emit('ok', {
        ...this.SemEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
